import * as React from 'react';
import Text from 'antd/lib/typography/Text';
import Collapse from 'antd/lib/collapse';
import { ItemType } from 'rc-collapse/es/interface';
import { releaseStepModuleTitleStyle, antGrey } from '@/components/styles/globalStyles';
import Space from 'antd/lib/space';
import Divider from 'antd/lib/divider';
import { AppStoreItemsCard } from '@/components/AppStoreItems/AppStoreItemsCard';

export interface AppStoreCollapsibleItem {
    header: React.ReactNode;
    content: React.ReactNode;
    extra?: React.ReactNode | ((isExpanded: boolean) => React.ReactNode);
}
export interface AppStoreItemsCollapseProps {
    header?: React.ReactNode;
    collapsibleItems: AppStoreCollapsibleItem[];
}

export const AppStoreItemsCollapse: React.FC<AppStoreItemsCollapseProps> = ({ header, collapsibleItems }) => {
    const [activeKeys, setActiveKeys] = React.useState<string[]>([]);

    return (
        <AppStoreItemsCard>
            {!!header && (
                <>
                    {header}
                    <div
                        style={{
                            width: '100%',
                            height: 1,
                            borderBottom: `1px solid ${antGrey.grey5}`,
                        }}
                    />
                </>
            )}
            <Collapse
                defaultActiveKey={[]}
                className="build-module-collapse"
                style={{
                    backgroundColor: antGrey.grey2,
                }}
                onChange={(activeKeys) => {
                    setActiveKeys(activeKeys as string[]);
                }}
                items={collapsibleItems.map((item, index) => {
                    const collapsibleItem: ItemType = {
                        label:
                            typeof item.header === 'string' ?
                                <Text style={{ ...releaseStepModuleTitleStyle, alignSelf: 'center' }}>
                                    {item.header}
                                </Text>
                            :   item.header,
                        children: item.content,
                        key: index,
                        style: {
                            padding: '6px 0',
                        },
                        extra: (
                            <div
                                style={{
                                    position: 'relative',
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                            >
                                {typeof item.extra === 'function' ?
                                    item.extra(activeKeys.includes(index.toString()))
                                :   <Space
                                        split={<Divider type="vertical" style={{ backgroundColor: antGrey.grey3 }} />}
                                    >
                                        {item.extra}
                                    </Space>
                                }
                            </div>
                        ),
                    };
                    return collapsibleItem;
                })}
            />
        </AppStoreItemsCard>
    );
};
